var autoPlaySpeed = $('.block-hero-slider').attr('data-slick');

$('.block-hero-slider').slick({
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: autoPlaySpeed,
    dots: true,
    pauseOnHover: true
});

//Track content impressions of the slides
let blockherosliderChangeHandler = function (event, slick, currentSlide) {
    let _paq = window._paq = window._paq || [];
    let slide = $(slick.$slides[currentSlide]).find('[data-track-content]');
    if (slide && !$(slide).attr('data-tracked')) {
        _paq.push(['trackContentImpression', $(slide).attr('data-content-name'), $(slide).attr('data-content-piece'), $(slide).attr('data-content-target')]);
        $(slide).attr('data-tracked', true);
        $(slide).click(function () {
            _paq.push(['trackContentInteraction', 'click', $(slide).attr('data-content-name'), $(slide).attr('data-content-piece'), $(slide).attr('data-content-target')]);
        });
    }
};
$('.block-hero-slider').on('afterChange', blockherosliderChangeHandler);

$('.block-cards-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 1259,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 767,
            settings: "unslick"

            //{
            //    slidesToShow: 1,
            //    slidesToScroll: 1
            //}
        }]
});
